import { API_URL } from '../../config';

/* Réalisations publiées depuis l'espace admin (photos, vidéo, type, délai…) — partagé accueil / page Réalisations */
let cache = null;
export function fetchRealisations() {
  if (!cache) {
    cache = fetch(API_URL + '/config/realisations')
      .then(r => (r.ok ? r.json() : []))
      .then(d => (Array.isArray(d) ? d : []))
      .catch(() => { cache = null; return []; });
  }
  return cache;
}

// « 7 » → « 7 jours », « 705 » → « 705 modules » (si l'admin n'a saisi qu'un nombre)
const unite = (v, u) => { const t = String(v || '').trim(); return /^\d+([.,]\d+)?$/.test(t) ? `${t} ${u}` : t; };

export function mapReal(r) {
  return {
    id: 'dyn_' + r.id, rid: r.id, titre: r.titre || '', lieu: r.lieu || '', type: r.type || 'Hangar Agricole',
    systeme: r.systeme || '', puissance: unite(r.puissance, 'kWc'), modules: unite(r.modules, 'modules'), duree: unite(r.duree, 'jours'), mois: r.mois || '',
    imgs: (r.realisations_photos || []).slice().sort((a, b) => (a.ordre || 0) - (b.ordre || 0)).map(x => x.image_url).filter(Boolean),
    desc: r.description || '', prestations: r.prestations || [], video: r.video_url || '',
    accueil: r.afficher_accueil !== false,
  };
}

/* Lien vidéo → lecteur : YouTube, Vimeo, ou fichier .mp4 (Supabase, etc.) */
export function videoInfo(url) {
  const u = String(url || '').trim();
  if (!u) return null;
  const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (yt) return { kind: 'youtube', id: yt[1], embed: `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0&autoplay=1`, thumb: `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg` };
  const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return { kind: 'vimeo', id: vm[1], embed: `https://player.vimeo.com/video/${vm[1]}?autoplay=1`, thumb: '' };
  return { kind: 'file', src: u, thumb: '' };
}
